import OutboundLink from 'components/OutboundLink';


function PDFLink(props) {
	let { text } = props;
	return <OutboundLink url={text} iconOnly />;
}

export default PDFLink;
